import React, {useState} from 'react';
import {CCard, CCardBody, CCardHeader, CCol, CDataTable, CRow} from '@coreui/react';
//@ts-ignore
import cloneDeep from 'lodash/cloneDeep';

const CDataTableGroupExpandable = (props: any) => {
  const {
    data,
    dataFields,
    columnNames,
    divStyle,
    panelHeader,
    cRowClass,
    mdColSize,
    headerText,
    perPageSelect,
    paginationStyle,
    scopedSlots,
    noItemsViewSlot,
    useColumnFilters,
    getExpansionItemDetails,
    defaultExpansionItemSummary,
  } = props;
  const [tableData, setTableData] = useState<any>(data);
  const [expandedItems, setExpandedItems] = useState<any>(null);

  const toggleDetails = (item: any) => {
    //console.log("Toggle details clicked, toggling for item: ", item)
    const position = tableData.indexOf(item);
    //console.log("Item position is: ", position)
    const newTableData = tableData;
    if (expandedItems !== null && expandedItems.length > 0 && expandedItems.includes(item)) {
      // Means we are clicking hide, item is already expanded
      setExpandedItems(expandedItems.filter((expandedItem: any) => expandedItem !== item));
      newTableData.splice(position + 1, 1);
    } else {
      let newItem = {...defaultExpansionItemSummary};
      newItem = getExpansionItemDetails(newItem, item);

      //console.log("New table item is: ", newItem)
      const returnItem = cloneDeep(newItem);
      setExpandedItems(expandedItems === null ? [item] : [...expandedItems, item]);
      newTableData.splice(position + 1, 0, returnItem);
    }
    //console.log("New table data is: ", newTableData)
    setTableData(newTableData);
  };

  return (
    <div style={divStyle}>
      {!useColumnFilters && (
        <div>
          <div>{panelHeader}</div>
          <CRow className={cRowClass}>
            <CCol md={mdColSize}>
              <CCard>
                <CCardHeader>{headerText}</CCardHeader>
                <CCardBody>
                  <CDataTable
                    items={tableData}
                    fields={dataFields}
                    columnHeaderSlot={columnNames}
                    tableFilter
                    itemsPerPageSelect={perPageSelect}
                    itemsPerPage={perPageSelect.items}
                    hover
                    sorter
                    pagination={paginationStyle}
                    noItemsViewSlot={noItemsViewSlot}
                    scopedSlots={scopedSlots}
                  />
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>
      )}
      {useColumnFilters && (
        <div>
          <div>{panelHeader}</div>
          <CRow className={cRowClass}>
            <CCol md={mdColSize}>
              <CCard>
                <CCardHeader>{headerText}</CCardHeader>
                <CCardBody>
                  <CDataTable
                    items={tableData}
                    fields={dataFields}
                    columnHeaderSlot={columnNames}
                    tableFilter
                    columnFilter
                    itemsPerPageSelect={perPageSelect}
                    itemsPerPage={perPageSelect.items}
                    hover
                    sorter
                    pagination={paginationStyle}
                    noItemsViewSlot={noItemsViewSlot}
                    scopedSlots={scopedSlots}
                  />
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>
      )}
    </div>
  );
};

export default CDataTableGroupExpandable;
